import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/rafiki.svg'


const _withScopeId = n => (_pushScopeId("data-v-fd6e4842"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "faq-overview d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "faq-left" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Frequently Asked Questions"),
    /*#__PURE__*/_createElementVNode("p", null, "Everything you need to know about BeHalal")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "faq-right d-none d-md-block" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "w-100"
    })
  ])
], -1))
const _hoisted_2 = { class: "faq-questions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "FAQs", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_faq_question = _resolveComponent("faq-question")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    footer: true,
    download: true
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_faq_question, {
          question: "What is Halal?",
          answer: "Halal is an Islamic banking and financial technology app that allows you to gain access to save money,\n        create ajo between with family and friends and also allows you seek for zero interest loans. Halal Is\n        an alternative to high interest loan, if you pick an early slot number in an Ajo group, you get the first fund\n        collection by paying a one-time fee while people who collect late in an ajo group get an additional bonus and do\n        not have to pay any fee. You can also make your utility bill payments, airtime and data purchase on the app."
        }),
        _createVNode(_component_faq_question, {
          question: "What is Islamic banking?",
          answer: "According to the Islamic and sharia law binding the Muslim community, the loan you give to people should\n        be without interest."
        }),
        _createVNode(_component_faq_question, {
          question: "As a Christian, can I make use of Halal?",
          answer: "Yes, according to Deuteronomy 23:19, “You shall not charge interest on loans to your brother, interest on\n        money, interest on food, interest on anything that is lent for interest. You may charge a foreigner interest, but\n        you may not charge your brother interest, that the Lord your God may bless you in all that you undertake in the\n        land that you’re entering to take possession of it.”"
        }),
        _createVNode(_component_faq_question, {
          question: "Can I re-name my ajo savings to suit a purpose?",
          answer: "You can change the name and also personalize it for specific reasons, e.g. Holiday expense, Savings for brand\n        new car"
        }),
        _createVNode(_component_faq_question, {
          question: "Can I run my ajo simultaneously with my savings?",
          answer: "We usually advise that you do this."
        }),
        _createVNode(_component_faq_question, {
          question: "Is there a referral bonus for me if I invite someone?",
          answer: "Yes. This also applies if you start an Ajo Group."
        }),
        _createVNode(_component_faq_question, {
          question: "How do I join Halal?",
          answer: "Start your journey to financial freedom today with Halal by downloading the Halal mobile app from the Google\n        Play Store or IOS App Store. Once downloaded, the account creation process is as simple as typing on your device.\n        Follow the instructions and fill out the necessary information - by providing your full name (this must match your\n        bank account name and identity cards name), phone number, email address, password and transaction pin. Upon gaining\n        access to the app, you are expected to verify your phone number, email address, and identity. It is important that\n        you use a photo of yourself as your profile picture to prevent your account from being suspended."
        }),
        _createVNode(_component_faq_question, {
          question: "What is the process involved for ajo?",
          answer: "You create a group or join an existing group"
        }),
        _createVNode(_component_faq_question, {
          question: "What is the process involved for savings?",
          answer: "Upon downloading the app, register with your card, verify your BVN and you can start saving."
        }),
        _createVNode(_component_faq_question, {
          question: "Why do I need to verify my BVN? Is it safe?",
          answer: "You need to verify your BVN so we can be sure that the bank account you will be withdrawing into belongs to you.\n        Yes, it is completely safe, and encrypted. Do not send your BVN to us, just enter it on the App and verify."
        }),
        _createVNode(_component_faq_question, {
          question: "Can I join more than one ajo group?",
          answer: "You are allowed to join only 3 active Ajo groups at a time. To avoid loading yourself with excessive contribution\n        debts, as you cannot leave a group once it has started."
        }),
        _createVNode(_component_faq_question, {
          question: "Is there a limit on bank transfers?",
          answer: "No, you can make as many bank transfers as your business or personal lifestyle demands."
        }),
        _createVNode(_component_faq_question, {
          question: "How do I transfer from my ajo wallet to my bank?",
          answer: "Click ‘Withdraw’ on your home page and fill the necessary information."
        }),
        _createVNode(_component_faq_question, {
          question: "Is Halal a registered company?",
          answer: "Yes, we are registered with Corporate Affairs Commission and we have licenses to operate."
        }),
        _createVNode(_component_faq_question, {
          question: "Can I get a loan from Halal?",
          answer: "Yes, you can. However, you have to be a verified Halal user. Register your business with us\n        and one of our agents will be on hand to verify your business and there you go."
        }),
        _createVNode(_component_faq_question, {
          question: "Can I exit the ajo platform after starting?",
          answer: "No, you can’t exit an ajo platform, until the cycle is done."
        }),
        _createVNode(_component_faq_question, {
          question: "Can I withdraw my savings / locked funds before due date?",
          answer: "No, until the desired date"
        }),
        _createVNode(_component_faq_question, {
          question: "Can I withdraw my ajo before my cash out date?",
          answer: "No you can’t, until the due date, but in case of emergency, you can speak to your Ajo\n        coordinator and swipe your collection date with someone else within your group."
        }),
        _createVNode(_component_faq_question, {
          question: "How can I pay into my group ajo wallet?",
          answer: "Click on your group, scroll right to contribute, and make payment."
        }),
        _createVNode(_component_faq_question, {
          question: "Today is my cash out day, what time should I expect my money?",
          answer: "You will definitely get your money before the end of the day."
        }),
        _createVNode(_component_faq_question, {
          question: "How can I create an ajo group?",
          answer: "Click on groups, and click on the Cross cycle at the bottom right corner to create your group.\n        You are the admin of any group you create, and you have the responsibility to invite people to join\n        your group. You get an admin bonus for any group you create"
        }),
        _createVNode(_component_faq_question, {
          question: "Can I create more than one ajo group?",
          answer: "Yes, at least a minimum of 3 group per cycle depending on the category of the ajo group"
        }),
        _createVNode(_component_faq_question, {
          question: "Can I join public ajo?",
          answer: "Yes."
        }),
        _createVNode(_component_faq_question, {
          question: "Is the public ajo group verified?",
          answer: "Yes, every public group is verified"
        }),
        _createVNode(_component_faq_question, {
          question: "Can I trust the public ajo?",
          answer: "Yes, you can"
        })
      ])
    ]),
    _: 1
  }))
}